// extracted by mini-css-extract-plugin
module.exports = {"JobSummary":"JobSummary__2nNxi","JobSummaryTableContainer":"JobSummaryTableContainer__wL2Q3"};